<template>
  <div class="header header-fix">
    <van-nav-bar
        safe-area-inset-top
        :title='this.$route.meta.title'
        @click-left="onClickLeft"
    >
      <template #left v-if="this.$route.meta.iconLeft">
        <van-icon name="arrow-left" class="font" />
      </template>
    </van-nav-bar>
  </div>
</template>
<script>
export default {
  name:'',
  data(){
    return{
    }
  },
  methods:{
    onClickLeft(){
        this.$router.go(-1);
    },
  },
  created(){

  }
}
</script>
<style lang="scss" scoped>
.header-fix{
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10;
  width: 100%;
  height: 90px;
}
.font{
  font-size:40px
}
</style>
